export class FetchRosterForGame {
    public static readonly type = '[Roster] FetchRosterForGame';
    constructor(public gameId: string) {}
}
